
import React from 'react'
import DetailContainer from '../MainPage/common/DetailContainer'
import { images } from '../common/images';

function FrequencyDetailContainer({ phaseLoadLogs, phaseWiseData, phase, deviceId, multipleDaysLogs }) {
  
  // Find the last valid log that doesn't have the 'ct' key which means that log will be of 'disconnect' type
  const validPhaseData = phaseWiseData.filter(log => !log.hasOwnProperty('ct')).sort((a, b) => a.ts - b.ts);
  // Check if there is a valid log to display
  const lastValidLog = validPhaseData.length > 0 ? validPhaseData[validPhaseData.length - 1] : null;
  return (
    <DetailContainer
      name={`Frequency ${Object.keys(phaseLoadLogs[deviceId]).length > 1 ? Number(phase) + 1 : ''}`}
      value={`${(Object.keys(phaseLoadLogs)?.length === 1 &&
        lastValidLog
        ? lastValidLog.f
        : 0
      )?.toFixed(2)} Hz`}
        time={
        Object.keys(phaseLoadLogs)?.length !== 0 &&
          phaseWiseData.length !== 0 &&
          lastValidLog !== null &&
          lastValidLog.ts !== undefined &&
          lastValidLog.ts !== null
          ? lastValidLog.ts
          : 0
      }
      showDay={multipleDaysLogs?.length > 1 ? true : false}
      color={"#FDECEC"}
      borderColor={"#EF4444"}
      image={images.voltage}
    />
  );
}


export default FrequencyDetailContainer